/**
 * D-420 — çağrı ekranındaki tek arıza yuvası.
 *
 * Ekran, arıza ve uyarı satırlarını üst üste diziyordu: ham hata, çevirili
 * hata, ses yolu hatası, Bluetooth izin satırı ve "ses taşınmıyor" notu aynı
 * anda görünebiliyordu. Beşi de çizildiğinde üst blok şişiyor, asıl bilgi
 * kayboluyordu.
 *
 * Arızalar birbirinin YERİNE geçer, üstüne değil: aynı anda yalnız en
 * öncelikli olan gösterilir. Sıra, kullanıcının yapabileceğine göre kurulur.
 */
export type CallFault =
  | { kind: 'error'; text: string }
  | { kind: 'errorKey'; translationKey: string }
  | { kind: 'bluetoothPermission' }
  | { kind: 'audioRoute' };

export function callFault(input: {
  error: string | null;
  errorTranslationKey: string | null;
  bluetoothPermissionDenied: boolean;
  audioRouteError: boolean;
}): CallFault | null {
  // 1) Çağrının kendisi başarısız olduysa en ağırı budur: kullanıcının az önce
  //    yaptığı eylem (kabul, ret, kapatma) gerçekleşmemiştir.
  if (input.error) return { kind: 'error', text: input.error };
  if (input.errorTranslationKey) {
    return { kind: 'errorKey', translationKey: input.errorTranslationKey };
  }
  // 2) İzin reddi kullanıcının DÜZELTEBİLECEĞİ tek durumdur ve kendi
  //    dokunuşunun sonucudur; salt bilgilendiren ses yolu hatasının önünde.
  if (input.bluetoothPermissionDenied) return { kind: 'bluetoothPermission' };
  if (input.audioRouteError) return { kind: 'audioRoute' };
  return null;
}
